import styled from "styled-components";
import { useScrollReveal } from "../hooks/useScrollReveal";
import { revealDelayStyle } from "../styles/scrollReveal";
import { SectionTitle } from "./common/SectionTitle";
import AccuracyImg from "../../../assets/images/pluvaIonLanding/stats_accuracy.jpg";
import DisplayImg from "../../../assets/images/pluvaIonLanding/stats_display.jpg";
import SatellitesImg from "../../../assets/images/pluvaIonLanding/stats_satellites.png";
import SpeedImg from "../../../assets/images/pluvaIonLanding/stats_speed.jpg";

const stats = [
  {
    img: AccuracyImg,
    alt: "±2.5cm",
    desc: "한 뼘의 오차도 허용않는\n초정밀 자율 주행",
  },
  {
    img: DisplayImg,
    alt: '10.1"',
    desc: "뙤약볕 아래서도\n선명한 고휘도 디스플레이",
  },
  {
    img: SatellitesImg,
    alt: "50+개",
    desc: "다중 위성 연결로\n끊김 없는 위치 정밀도",
  },
  {
    img: SpeedImg,
    alt: "0.1km/h",
    desc: "초저속에서도\n흔들림 없는 안정적인 조향",
  },
];

const STAT_ORDER = [0, 1, 2, 3];

export const StatsSection = () => {
  const titleReveal = useScrollReveal(0.4);
  const gridReveal = useScrollReveal(0.35);

  return (
    <Container>
      <SectionTitle ref={titleReveal.ref} $visible={titleReveal.isVisible}>
        {"숫자로 보는 아이온"}
      </SectionTitle>

      <Grid ref={gridReveal.ref}>
        {stats.map((stat, i) => (
          <Cell key={i} $borderRight={i % 2 === 0} $borderBottom={i < 2}>
            <StatImage
              src={stat.img}
              alt={stat.alt}
              loading="lazy"
              $visible={gridReveal.isVisible}
              $delay={STAT_ORDER[i] * 120}
            />
            <StatDesc
              $visible={gridReveal.isVisible}
              $delay={STAT_ORDER[i] * 120 + 150}
            >
              {stat.desc}
            </StatDesc>
          </Cell>
        ))}
      </Grid>

      <CallButton
        id="ion-call-stats"
        onClick={() => {
          window.location.href = "tel:15335502";
        }}
      >
        {"1533-5502"}
      </CallButton>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 40px;
  align-self: stretch;

  padding: 56px 24px 48px;
  background-color: #000000;
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-self: stretch;
`;

const Cell = styled.div<{
  $borderRight: boolean;
  $borderBottom: boolean;
}>`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 40px;

  padding: 40px 16px;

  border-right: ${({ $borderRight }) =>
    $borderRight ? "1px solid #9EBDCC" : "none"};
  border-bottom: ${({ $borderBottom }) =>
    $borderBottom ? "1px solid #9EBDCC" : "none"};
`;

const StatImage = styled.img<{
  $visible: boolean;
  $delay: number;
}>`
  width: 100%;
  max-width: 140px;
  object-fit: contain;

  ${revealDelayStyle}
`;

const StatDesc = styled.p<{
  $visible: boolean;
  $delay: number;
}>`
  color: #c3d7e2;
  text-align: center;
  white-space: pre-line;

  font-family: Pretendard;
  font-size: 12px;
  font-weight: 600;
  line-height: 130%;

  ${revealDelayStyle}
`;

const CallButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  align-self: stretch;
  margin-top: 10px;
  height: 59px;
  padding: 0 18px;
  border-radius: 12px;

  background:
    linear-gradient(
        279.13deg,
        #003993 1.11%,
        #033686 3.95%,
        #0c316a 11.33%,
        #132d54 19.74%,
        #182a43 29.46%,
        #1c2836 41.32%,
        #1e272f 57.6%,
        #1f272e 98.89%
      )
      padding-box,
    linear-gradient(
        279.13deg,
        #003993 0%,
        #01378c 15%,
        #162b48 40%,
        #1f272e 55%,
        #232d35 65%,
        #313e49 75%,
        #475a6a 85%,
        #668097 92%,
        #7593ad 100%
      )
      border-box;
  border: 3px solid transparent;

  color: #ffffff;
  font-family: Pretendard;
  font-size: 28px;
  font-weight: 700;
  line-height: 130%;
  letter-spacing: 0px;
`;
